import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { ApplicantData } from '@trnsact/trnsact-scorecard-sdk';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { SelectOption } from 'global';
import { ConditionsFieldsTypes } from '../../../../modules/jsonRulesCriterias/scorecardCriteria/types';
import { factKeyToLabel } from '../../../../modules/jsonRulesCriterias/lib/convertFactToSelectOptions';
import { ApplicantField } from './ApplicantField';

interface ApplicantDataFormProps {
  applicantData: ApplicantData | null;
  listOfFacts: Map<
    string,
    {
      fact: string;
      type: ConditionsFieldsTypes;
      factType: FACT_NAMES_BOOLEAN | FACT_NAMES_NUMERIC | FACT_NAMES_STRING;
    }
  >;
  stringFactOptions: Map<string, SelectOption[]>;
  manualFields: { [key: string]: any };
  onFieldChange: (key: string, value: any) => void;
}

export const ApplicantDataForm: React.FC<ApplicantDataFormProps> = ({
  applicantData,
  listOfFacts,
  stringFactOptions,
  manualFields,
  onFieldChange,
}) => {
  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
        Applicant Data
      </Typography>
      <Grid container spacing={2}>
        {Array.from(listOfFacts.values()).map((factObj: any) => {
          const key = factObj.fact;
          const label = factKeyToLabel(key);
          let value = manualFields[key] ?? (applicantData ? (applicantData as any)[key] : '');

          return (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    mb: 0.5,
                    fontWeight: 500,
                    color: 'text.secondary',
                    fontSize: '0.813rem',
                  }}
                >
                  {label}
                </Typography>
                <ApplicantField
                  factKey={key}
                  factType={factObj.type}
                  factName={factObj.factType}
                  value={value}
                  onChange={onFieldChange}
                  stringOptions={stringFactOptions.get(key)}
                />
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
